import { useCallback, useMemo } from 'react'

import { Note, useGetTabNoteListInfiniteQuery } from 'integration/resources/wallet'

import { UseTabComponent } from './types'

const notesMergeDataInfiniteQuery = (
  data: ReturnType<typeof useGetTabNoteListInfiniteQuery>['data']
) =>
  data?.pages.reduce<Note[]>(
    (previousValue, currentValue) => [...previousValue, ...currentValue.data.data],
    []
  ) ?? []

export const useTabComponent: UseTabComponent = ({ tabNumber }) => {
  const {
    data: allNotesData,
    isFetchingNextPage: allNotesIsFetchingNextPage,
    hasNextPage: allNotesHasNextPage,
    fetchNextPage: allNotesFetchNextPage,
    isLoading
  } = useGetTabNoteListInfiniteQuery({
    id: tabNumber
  })

  const allNotes = useMemo(() => notesMergeDataInfiniteQuery(allNotesData), [allNotesData])

  const onScrollEndDragAllNotesList = useCallback(() => {
    if (!allNotesIsFetchingNextPage && allNotesHasNextPage) {
      allNotesFetchNextPage()
    }
  }, [allNotesIsFetchingNextPage, allNotesHasNextPage, allNotesFetchNextPage])

  return { allNotes, onScrollEndDragAllNotesList, allNotesIsFetchingNextPage, isLoading }
}
